import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum OrderEditKind {
  ADDRESS = "address",
  CANCEL = "cancel",
  VARIANT_CHANGE = "variant_change",
  ADD_PRODUCT = "add_product",
  REMOVE_PRODUCT = "remove_product",
  DISCOUNT = "discount",
  ADD_QUANTITY = "add_quantity",
  REMOVE_QUANTITY = "remove_quantity",
  CONTACT_INFO = "contact_info",
}

export enum OrderEditSource {
  "SUPPORT_AI" = "support_ai",
  "SUPPORT_SELF_SERVICE" = "support_self_service",
  "CUSTOMER_PORTAL_SELF_SERVICE" = "customer_portal_self_service",
  "EMAIL_ONE_CLICK_UPSELL" = "email_one_click_upsell",
}

export enum LineItemDiffChangeType {
  ADDED = "added",
  REMOVED = "removed",
  QUANTITY_ADDED = "quantity_added",
  QUANTITY_REMOVED = "quantity_removed",
}

const LineItemDiffSchema = z.object({
  lineItemId: z.string(),
  variantId: z.string().nullish(),
  productTitle: z.string().nullish(),
  variantTitle: z.string().nullish(),
  sku: z.string().nullish(),
  quantityBefore: z.number(),
  quantityAfter: z.number(),
  changeType: createEnum(LineItemDiffChangeType, {
    enumName: "LineItemDiffChangeType",
  }),
});

export const OrderEditSchema = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  kind: createEnum(OrderEditKind, { enumName: "OrderEditKind" }),
  source: createEnum(OrderEditSource, { enumName: "OrderEditSource" }),
  redoOrderId: zExt.objectId().nullish(),
  customerName: z.string(),
  orderNumber: z.string(),
  createdAt: z.date(),
  orderCreatedAt: z.date(),
  totalPriceBefore: z.string().nullish(),
  totalPriceAfter: z.string().nullish(),
  /** Shop currency of the price fields. Absent on records written before both sides were normalized to shop money. */
  currency: z.string().nullish(),
  lineItemDiff: z.array(LineItemDiffSchema).min(1).nullish(),
});

export type OrderEdit = z.infer<typeof OrderEditSchema>;
export type LineItemDiff = z.infer<typeof LineItemDiffSchema>;
